import { Box, ClickAwayListener, Fade, Stack } from "@mui/material";
import React, { useState } from "react";
import { jobIsFetti } from "../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Color, FontStyle } from "../../constants";
import { JobFloatScreen } from "../../utils/jobUtils";
import CloseIcon from "@mui/icons-material/Close";
import FlagIcon from "@mui/icons-material/Flag";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import * as apiService from "../../service/ApiService";
import ReportJobFloat from "./ReportJobFloat";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";

const styles = {
  menuIcon: ({ hovered, hoverColor = "#f66" }) => {
    return {
      width: "20px",
      height: "20px",
      color: hovered ? hoverColor : "#aaa",
      transition: "color 0.2s",
      // color: hovered ? Color.deeperPurple + "a0" : "#aaa",
    };
  },
};

const OptionRow = ({ text, onClick, icon = null }) => {
  const [bgColor, setBgColor] = useState("transparent");
  const [hovered, setHovered] = useState(false);
  const [shouldTransition, setShouldTransition] = useState(true);
  const flash = (color) => {
    let ts = 0;
    const interval = setInterval(() => {
      ts += 1;
      if (ts === 1 || ts === 9) {
        // if (ts === 1) {
        setBgColor(color);
      } else if (ts === 6 || ts === 14) {
        // } else if (ts === 7 || ts === 16) {
        setBgColor("transparent");
      } else if (ts > 20) {
        setShouldTransition(true);
        clearInterval(interval);
      }
    }, 1000 / 60);
  };
  const handleClick = (e) => {
    e.stopPropagation();
    setShouldTransition(false);
    flash(Color.primaryLight);
    setTimeout(() => {
      onClick();
    }, 250);
  };
  return (
    <Stack
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        ...FontStyle.body,
        fontSize: "14px",
        color: "#000",
        // color: "#888",
        py: "5px",
        paddingLeft: "16px",
        backgroundColor: bgColor,
        cursor: "pointer",
        transition: shouldTransition ? "background-color 0.2s" : "none",
        "&:hover": {
          backgroundColor: bgColor === "transparent" ? "#eef" : bgColor,
        },
        // borderBottom: "1px solid #ddd",
      }}
      direction="row"
      alignItems="center"
      justifyContent="flex-start"
      spacing="10px"
      onClick={handleClick}>
      {icon && icon({ hovered })}
      <Box>{text}</Box>
    </Stack>
  );
};

const JobDetailsMenu = ({
  job,
  fav,
  setFav,
  canCollapse = false,
  handleCollapse = null,
}) => {
  const dispatch = useDispatch();
  const {
    jobId,
    company,
    jobTitle,
    location,
    locations,
    roleToken,
    experienceLevel,
    jobDescription,
    url,
    vidUrl,
    vidSize,
  } = job;
  const isFetti = jobIsFetti(jobId);
  const auth = useSelector((state) => state.auth);
  const [menuOpen, setMenuOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);

  const toggleFav = () => {
    setFav((fav) => {
      // from FavHeartContainer.js
      // api call to toggle fav (this will also dispatch to global state)
      apiService.toggleFavJob(dispatch, {
        ...auth.accountData,
        jobId,
        isFav: !fav,
      });
      // return the new fav state, for local state
      return !fav;
    });
    setMenuOpen(false);
  };
  const handleCancel = () => {
    setMenuOpen(false);
  };

  const handleReport = () => {
    setMenuOpen(false);
    setReportOpen(true);
  };
  return (
    <Stack
      sx={{
        direction: "column",
        position: "relative",
        zIndex: (menuOpen || reportOpen) && 102,
        // backgroundColor: "#0008",
      }}
      justifyContent="center"
      alignItems="center">
      <MoreVertIcon
        onClick={(e) => {
          e.stopPropagation();
          setMenuOpen((o) => !o);
        }}
        sx={{
          //   width: "20px",
          //   height: "20px",
          color: menuOpen ? Color.deeperPurple + "a0" : "#aaa",
          position: "relative",
          left: "3px",
          cursor: "pointer",
          transition: "color 0.2s",
          "&:hover": {
            color: Color.deeperPurple + "a0",
          },
        }}
      />
      <ClickAwayListener
        onClickAway={() => {
          setMenuOpen(false);
        }}>
        <Fade in={menuOpen} timeout={300}>
          <Stack
            direction="column"
            sx={{
              position: "absolute",
              top: "calc(100% + 1px)",
              left: { xs: "unset", md: "calc(100% - 12px)" },
              right: { xs: "4px", md: "unset" },
              width: canCollapse ? "122px" : "115px", // longer for collapse since the word Collapse is longer
              backgroundColor: "#fff",
              borderRadius: "4px",
              overflow: "hidden",
              boxShadow: "0px 0px 4px #0004",
              zIndex: 2,
              py: 1,
            }}>
            <OptionRow
              text={fav ? "Unlike" : "Like"}
              onClick={toggleFav}
              icon={({ hovered }) => {
                return fav ? (
                  <FavoriteBorderOutlinedIcon
                    sx={styles.menuIcon({ hovered })}
                  />
                ) : (
                  <FavoriteIcon sx={styles.menuIcon({ hovered })} />
                );
              }}
            />
            {/* collapsing for mobile view with expanded job details */}
            {canCollapse && (
              <OptionRow
                text="Collapse"
                onClick={handleCollapse}
                icon={({ hovered }) => {
                  return (
                    <CloseFullscreenIcon
                      sx={{
                        ...styles.menuIcon({
                          hovered,
                          hoverColor: Color.deepPurple + "80",
                        }),
                        transform: "rotate(180deg) scale(0.8)",
                      }}
                    />
                  );
                }}
              />
            )}
            <OptionRow
              text="Report"
              onClick={handleReport}
              icon={({ hovered }) => {
                return (
                  <FlagIcon
                    sx={styles.menuIcon({ hovered, hoverColor: "#d99" })}
                  />
                );
              }}
            />
            <OptionRow
              text="Cancel"
              onClick={handleCancel}
              icon={({ hovered }) => {
                return (
                  <CloseIcon
                    sx={styles.menuIcon({
                      hovered,
                      hoverColor: Color.deepPurple + "80",
                    })}
                  />
                );
              }}
            />
          </Stack>
        </Fade>
      </ClickAwayListener>
      {menuOpen && <JobFloatScreen zIndex={1} />}
      <ReportJobFloat
        show={reportOpen}
        handleClose={() => setReportOpen(false)}
        job={job}
      />
    </Stack>
  );
};

export default JobDetailsMenu;
